var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiTabs from '@material-ui/core/Tabs';
/**
 * Kareo wrapped component of the Material-UI Tabs. The prop API has been limited to props defined in TabsProps.
 *
 * Tabs make it easy to explore and switch between different views.
 *
 * Material-UI Tabs: [Docs](https://v4.mui.com/components/tabs/), [Tabs API](https://v4.mui.com/api/tabs/)
 *
 * @storybook: [Tabs](http://design.kareoprod.ent/design-system/?path=/docs/components-navigation--tabs-example)
 */
var Tabs = function (props) { return (React.createElement(MuiTabs, __assign({}, props, { indicatorColor: "primary" }))); };
Tabs.defaultProps = {};
Tabs.displayName = 'KareoTabs';
export default Tabs;
